<div mat-dialog-content>
    <p [innerHTML]="message"></p>
</div>
<div mat-dialog-actions align="center">
    <button mat-button (click)="onNoClick()" cdkFocusInitial>Annuler</button>
    <button mat-button [matDialogClose]="true">Ok</button>
</div>

